// extracted by mini-css-extract-plugin
module.exports = {"box":"autoComplete_box__3MHpv","box__suggestion":"autoComplete_box__suggestion__OMcmL","box_input":"autoComplete_box_input__3KXyI"};